import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { rejoinCardImages as t } from "./rejoinCardImages.mjs";
import { useInfiniteListQuery as n } from "@maat/store-hooks";
import { propertiesApi as r } from "@maat/api-main";
//#region src/properties/useGuestFeedQuery.ts
var i, a = (a = 5) => n({
	queryKey: e.guestFeed(a),
	fetchPage: async (e) => {
		let n = await r.getGuestFeed({
			page: e,
			pageSize: a,
			seed: i
		});
		return !i && n.seed && (i = n.seed), {
			...n,
			categories: n.categories.map((e) => ({
				...e,
				properties: e.properties.map((e) => t(e, n.imageBase))
			}))
		};
	},
	key: "categories",
	staleTime: Infinity,
	refetchOnWindowFocus: !1
});
//#endregion
export { a as useGuestFeedQuery };
